import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";

import appVersion from "common/config/app-version.config";
import loginStyles from "features/login-screen/login.styles";

const useStyles = makeStyles(loginStyles);

function Footer() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <span className={classes.textGroup}>
        <Typography variant="body2" color="textSecondary">
          {`© ${new Date().getFullYear()} FYIsoft, Inc. All Rights Reserved.`}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Current version {appVersion}
        </Typography>
      </span>
      <span className={classes.textGroup}>
        <Link href="https://www.fyisoft.com/privacy-policy/" color="inherit">
          <Typography variant="body2" color="textSecondary">
            Terms and Conditions
          </Typography>
        </Link>
        <Link href="https://www.fyisoft.com/privacy-policy/" color="inherit">
          <Typography variant="body2" color="textSecondary">
            Privacy Policy
          </Typography>
        </Link>
      </span>
    </footer>
  );
}

export default Footer;
